(() => {
  $('.ProductListWrapper').on('click', '.product__colors a', function (e) {
    e.preventDefault();
    let currentImage = e.currentTarget;
    if (currentImage.classList.contains('currentVariant')) {
      return;
    }
    
    let productId = currentImage.dataset.product_id;
    let title = currentImage.dataset.title;
    let price = currentImage.dataset.price;
    let compareAtPrice = currentImage.dataset.compareAtPrice;
    let imageUrl = currentImage.dataset.imageUrl;
    let altImageUrl = currentImage.dataset.altImageUrl;
    let url = currentImage.dataset.url;
    let productInfoTags = currentImage.dataset.productInfoTags;

    let cardsProduct = $(`#productId_${productId}`)
    let productInfo = cardsProduct.find('.product-info-tags');
    productInfo.text(productInfoTags);
    let image = cardsProduct.find('.Image--fadeIn.lazyautosizes');
    let altImage = cardsProduct.find('.ProductItem__Image--alternate.lazyautosizes');

    if (altImage.length === 0 && altImageUrl !== '') {
      insertImageAltImage(cardsProduct, {title, altImageUrl});
      image.addClass('ProductItem__Image');
    }
    
    if (altImage.length === 1 && altImageUrl === '') {
      image.removeClass('ProductItem__Image');
      altImage.remove();
    }
    
    cardsProduct.find('.currentVariant').removeClass('currentVariant');
    currentImage.classList.add('currentVariant');
    cardsProduct.find('a').attr('href', url);
    cardsProduct.find('.ProductItem__Title').find('a').text(title);
    cardsProduct.find('.Price--highlight').find('.tlab-currency-format').text(formatter.format(price / 100));
    if (compareAtPrice != 0) {
      cardsProduct.find('.Price--compareAt').find('.tlab-currency-format').text(formatter.format(compareAtPrice / 100));
    } else {
      cardsProduct.find('.Price--compareAt').find('.tlab-currency-format').text('');
    }
    image.attr('srcset', imageUrl);
    altImage.attr('srcset', altImageUrl);
  })
  
  const insertImageAltImage = (cardsProduct, productJson) => {
    cardsProduct.find('.AspectRatio').append(`<img class="ProductItem__Image ProductItem__Image--alternate Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[200,300,400,600,800,900,1000,1200]" data-sizes="auto" alt="${productJson.title}" data-media-id="23187562266729" srcset="${productJson.altImageUrl}">`)
  }
  
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });

  // Handle gender filter toggle
  document.addEventListener('click', function(event) {
    if (event.target.closest('.Linklist__GenderToggle .Linklist__Item')) {
      document.querySelectorAll('.Linklist__GenderToggle .Linklist__Item').forEach(function(item) {
        item.classList.remove('active');
      });

      event.target.closest('.Linklist__Item').classList.add('active');
    }
  });
})();